import { render, staticRenderFns } from "./IPsyO.vue?vue&type=template&id=ed3203d8&scoped=true&"
import script from "./IPsyO.vue?vue&type=script&lang=js&"
export * from "./IPsyO.vue?vue&type=script&lang=js&"
import style0 from "./IPsyO.vue?vue&type=style&index=0&id=ed3203d8&prod&scoped=true&lang=scss&"
import style1 from "./IPsyO.vue?vue&type=style&index=1&id=ed3203d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3203d8",
  null
  
)

export default component.exports